import {NONE_STATUS, PENDING_STATUS, SUCCESS_STATUS} from "../../actions";
import axios from "axios";
import {getUpdateMediaUrl, getUpdateSpaceMediaUrl} from "../../actions/environment";
import {authConfig} from "../../actions/local-storage";
import {useState} from "react";
import useErrorHandler from "./use-error-handler";
import {useAuthorization} from "../../selectors";

/**
 * helper hook for creating and updating media synchronously (without redux)
 * -- refactor to use media calls instead of spacemedia which is deprecated --
 */
const useUpdateMedia = () => {
    const [status, setStatus] = useState(NONE_STATUS);
    const [media, setMedia] = useState(null);
    const {principalUsername} = useAuthorization();
    const {handleError, error} = useErrorHandler(setStatus);

    // data must be fully populated with a MediaRequest and contains mediaId
    // currently using media useState for both spacemedia and media -- refactor --
    const updateSpaceMedia = (spaceId, data, callback) => {
        setStatus(PENDING_STATUS);
        axios.post(getUpdateSpaceMediaUrl(principalUsername, spaceId), data, authConfig())
            .then(response => {
                setMedia(response.data);
                setStatus(SUCCESS_STATUS);
                callback && callback(response.data);
            })
            .catch(error => {
                console.log('updateSpaceMedia error', error);
                handleError(error, () => updateSpaceMedia(spaceId, data, callback));
            })
    }

    // data must be fully populated with a MediaRequest and contains mediaId
    // currently using media useState for both spacemedia and media -- refactor --
    const updateMedia = (spaceId, data, callback) => {
        setStatus(PENDING_STATUS);
        axios.post(getUpdateMediaUrl(principalUsername, spaceId), data, authConfig())
        .then(response => {
            setMedia(response.data);
            setStatus(SUCCESS_STATUS);
            callback && callback(response.data);
        })
        .catch(error => {
            console.log('updateMedia error', error);
            handleError(error, () => updateMedia(spaceId, data, callback));
        })
    }


    return {
        updateSpaceMedia: updateSpaceMedia,
        updateMedia: updateMedia,
        media, status, error}
}

export default useUpdateMedia;